'use strict';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    INITIAL_STATE,
    ROUTE_TO_ABMMODELOS,
    MODELOSCONTABLES_MOSTRAR_SPINNER,
    MODELOSCONTABLES_CARGAR_PERMISOS_USUARIO,
    MODELOSCONTABLES_POBLAR_GRILLA,
    MODELOSCONTABLES_CAMBIAR_ORDEN_GRILLA,
    MODELOSCONTABLES_MOSTRAR_ACTIVOS_GRILLA,
    MODELOSCONTABLES_FILTRAR_MODELOS,
    MODELOSCONTABLES_PRIMERA_CARGA
} from '../../Screens/ModelosContables/actions/Actions';

const initialState = {
    redirect: {
        shouldRedirect: false,
        to: null
    },
    primeraCargaPantalla: true,             //Flag que identifica si el renderizado es el inicial o no. De esta forma se ocultan descripciones que aún no deben ser evaluadas.
    mostrarSpinner: false,                  //Flag que indica si el spinner de carga debe mostrarse o no.
    permisosUsuario: [],                    //Array con los permisos sobre el Feature de CONTABILIDAD que tiene el usuario logeado.
    datosGrilla: [],                        //Array con el recordset de Modelos TOTALES devuelto de la obtención de datos.
    datosGrillaFiltrado: [],                //Array de los datos obtenidos en "datosGrilla" con filtros aplicados por el buscador, checkbox de Activos o columnas ordenadas.
    ordenGrilla: {                          //Objeto que determina qué orden tienen las diferentes columnas. El valor "true" se corresponde con un orden Ascendente y "false" con un orden Descendente.
        "codigo": true,
        "descripcion": true,
        "marca": true,
        "tipoMovimiento": true
    },
    columnaActivaOrdenamiento: undefined,   //Variable que determina a través de qué columna es la que está actualmente ordenada la grilla.
    checkRegistrosActivos: true,            //Flag que indica si el checkbox de registros activos está activado o no.
    inputBuscador: ""                       //Variable que guarda el input ingresado en el buscador de modelos.
}

function modelosContables(state = initialState, action) {
    LogHelper.In(modelosContables.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE: {
            state = initialState;


            result = {
                ...state
            }
        }
        break;

        case MODELOSCONTABLES_MOSTRAR_SPINNER: {
            result = {
                ...state,
                mostrarSpinner: action.valor
            }
        }
        break;

        case MODELOSCONTABLES_CARGAR_PERMISOS_USUARIO: {
            result = {
                ...state,
                permisosUsuario: action.permisos
            }
        }
        break;

        case MODELOSCONTABLES_PRIMERA_CARGA: {
            result = {
                ...state,
                primeraCargaPantalla: action.valor
            }
        }
        break;

        case MODELOSCONTABLES_POBLAR_GRILLA: {
            result = {
                ...state,
                datosGrilla: action.datosGrilla,
                datosGrillaFiltrado: action.datosGrillaActivos
            }
        }
        break;

        case MODELOSCONTABLES_CAMBIAR_ORDEN_GRILLA: {
            let datosOrdenados = [];

            //Reinicio valores ya que solo se podrá ordenar por una columna a la vez
            state.ordenGrilla = {
                "codigo": true,
                "descripcion": true,
                "marca": true,
                "tipoMovimiento": true
            };

            state.ordenGrilla[action.columna] = action.valor;

            datosOrdenados = ordenamientoColumnas(state.ordenGrilla, state.datosGrillaFiltrado, action.columna);

            result = {
                ...state,
                datosGrillaFiltrado: datosOrdenados,
                columnaActivaOrdenamiento: action.columna
            }
        }
        break;

        case MODELOSCONTABLES_MOSTRAR_ACTIVOS_GRILLA: {
            let datosOrdenados = action.datosGrilla;

            if(state.columnaActivaOrdenamiento){
                datosOrdenados = ordenamientoColumnas(state.ordenGrilla, action.datosGrilla, state.columnaActivaOrdenamiento);
            } else {
                datosOrdenados = ordenamientoColumnas(state.ordenGrilla, action.datosGrilla, "codigo");
            }

            result = {
                ...state,
                checkRegistrosActivos: action.valor,
                datosGrillaFiltrado: datosOrdenados
            }
        }
        break;

        case MODELOSCONTABLES_FILTRAR_MODELOS: {
            let datosOrdenados = action.modelosFiltradosBuscador;

            if(state.columnaActivaOrdenamiento){
                datosOrdenados = ordenamientoColumnas(state.ordenGrilla, action.modelosFiltradosBuscador, state.columnaActivaOrdenamiento);
            } else {
                datosOrdenados = ordenamientoColumnas(state.ordenGrilla, action.modelosFiltradosBuscador, "codigo");
            }

            result = {
                ...state,
                datosGrillaFiltrado: datosOrdenados,
                inputBuscador: action.valorInput
            }
        }
        break;
        
        case ROUTE_TO_ABMMODELOS: {
            result = {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data
                }
            }
        }
        break;

        default:
            result = {
                ...state
            };
            break;

    }

    LogHelper.Out(modelosContables.name, result);

    return result;
}


export default modelosContables;



/*****************************************************************FUNCIONES AUXILIARES***************************************************************** 
*********************************************************************************************************************************************************/
function ordenamientoColumnas(arrayEvaluar, arrayOrdenar, columnaActiva) {
    let datosOrdenados = [];

    if (arrayEvaluar[columnaActiva]) {
        datosOrdenados = arrayOrdenar.sort(function (a, b) {
            return ordernarArray(columnaActiva, a, b, 1, -1);
        });
    } else {
        datosOrdenados = arrayOrdenar.sort(function (a, b) {
            return ordernarArray(columnaActiva, a, b, -1, 1);
        });
    }

    return datosOrdenados;
}

function ordernarArray(nombreColumna, a, b, asc, desc) {
    LogHelper.In(ordernarArray.name, a, b, asc, desc);

    let firstRow = "";
    let SecondRow = "";

    switch (nombreColumna) {
        case "codigo": //Se realiza el ordenamiento como numérico y no como string.
            firstRow = a.Codigo;
            SecondRow = b.Codigo;
            break;
        case "descripcion":
            firstRow = a.Descripcion.toString().toUpperCase();
            SecondRow = b.Descripcion.toString().toUpperCase();
            break;
        case "marca":
            firstRow = a.Marca.toString().toUpperCase();
            SecondRow = b.Marca.toString().toUpperCase();
            break;
        case "tipoMovimiento":
            firstRow = a.Movimientos.toString().toUpperCase();
            SecondRow = b.Movimientos.toString().toUpperCase();
            break;
    }

    if (firstRow > SecondRow) {
        return asc;
    }
    if (firstRow < SecondRow) {
        return desc;
    }

    LogHelper.Out(ordernarArray.name, 0);
    return 0;
}